import React from 'react';
import styled, { css } from 'styled-components';
var SCUnorderedList = styled.ul.withConfig({
  displayName: "List__SCUnorderedList",
  componentId: "sc-n6qi9e-0"
})(["display:flex;flex-direction:column;text-align:left;margin-left:", ";padding-left:0;margin-bottom:0;list-style-type:", ";", ";"], function (props) {
  return props.noPadding ? 0 : '20px';
}, function (props) {
  return props.showBullets ? 'circle' : 'none';
}, function (props) {
  return props.isInline && css(["flex-direction:row;flex-wrap:wrap;list-style-type:none;margin:0;padding:0;> li{margin-left:22px;}"]);
});

var List = function List(props) {
  if (props.isOrdered) {
    return /*#__PURE__*/React.createElement("ol", {
      className: props.className
    }, props.children);
  } else {
    return /*#__PURE__*/React.createElement(SCUnorderedList, {
      isInline: props.isInline,
      showBullets: props.showBullets,
      className: props.className,
      noPadding: props.noPadding
    }, props.children);
  }
};

List.defaultProps = {
  isOrdered: false
};
export default List;